/* eslint-disable */

import '@/@fake-db/db'
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import ability from '@/plugins/casl/ability'
import layoutsPlugin from '@/plugins/layouts'
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import '@/styles/styles.scss'
import '@core/scss/template/index.scss'
import { abilitiesPlugin } from '@casl/vue'
import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import router from '@/router'
import Filters from '@/filters'
import VueChatScroll from 'vue3-chat-scroll-next'
import 'dashicons/dashicons.css'
import './assets/styles/index.scss'
import '@vuepic/vue-datepicker/dist/main.css'
// Highcharts removed from global imports for performance optimization
// Now loaded dynamically only when needed
import { CustomDirectives } from '@/plugins/customDirectives'
import { initSentry } from '@/plugins/sentry'
import { setupErrorHandlers, setupPolyfills } from '@/plugins/errorHandlers'
import { waitForWhiteLabelReady } from '@/utils/whiteLabelHelpers'
import { updateThemeAfterWhiteLabelReady } from '@/plugins/vuetify/theme'

loadFonts()

// Setup polyfills for browser compatibility
setupPolyfills()

// Create vue app
const app = createApp(App)
// Setup Plugins
const pinia = createPinia()

pinia.use(({ store }) => {
  store.$pinia = markRaw(pinia)
  store.$router = markRaw(router)
})
// Use plugins
app.use(vuetify)
app.use(pinia)
app.use(router)
app.use(layoutsPlugin)
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: false,
})
app.use(VueChatScroll)
// Highcharts Vue plugin removed from global registration
// app.use(VueReCaptcha, {
//   siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
//   loaderOptions: {
//     autoHideBadge: true, // Optional: Hides the badge
//     explicitRenderParameters: {
//       badge: 'bottomleft',
//     },
//   },
// })
// Customer Directive Registrar Plugin
app.use(CustomDirectives)
// Highcharts modules initialization removed from global scope
// Mount filters
app.config.globalProperties.$filters = Filters

// Setup error handlers
setupErrorHandlers(app)

// Sentry Error Tracking
initSentry(app, ['development'])
// Mount vue app
router.isReady().then(async () => {
  console.debug('[WL] router ready, waiting for WL session...')
  const ready = await waitForWhiteLabelReady(3000, 50)
  console.debug('[WL] mounting app', { ready })
  updateThemeAfterWhiteLabelReady()
  app.mount('#app')

})
